<template>
    <ds-modal
        is-open
        dialog
        size="med"
    >
        <h4 class="compliance-header">
            Do you have permission to text?
        </h4>

        <ul class="compliance-list">
            <li>The anti-spam rules and laws require contacts provide express opt-in <strong>consent before</strong> you send marketing texts.</li>
            <li>You must <strong>keep record</strong> of the permission according to applicable laws.</li>
            <li>Failure could result in legal action or <strong>fines and/or termination</strong> of Keap services.</li>
        </ul>

        <div class="agreement-container">
            <ds-checkbox
                v-model="checked"
                class="compliance-checkbox"
                label="I certify and confirm all contacts in this broadcast have provided prior express opt-in consent compliant with all laws to receive marketing texts from my company and that I will maintain those records as required by applicable laws."
            />
        </div>

        <div class="compliance-actions">
            <ds-text-button
                class="back-button"
                @click="$emit('close')"
            >
                Go back
            </ds-text-button>

            <ds-text-button
                data-qa="continue"
                :disabled="!checked"
                :loading="loading"
                @click="handleContinue"
            >
                Continue
            </ds-text-button>
        </div>
    </ds-modal>
</template>

<script>
import { SMS_OPT_STATUSES, CONSENT_ACQUISITION_KIND } from '@/components/broadcast/constants/smsBroadcast.constants';
import moment from 'moment-timezone';
import axios from 'axios';

export default {
    props: {
        numbersToBeSingleOptedIn: {
            type: Array,
            default: () => [],
        },
        userId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            checked: false,
            loading: false,
        };
    },

    created() {
    },

    methods: {
        handleContinue() {
            this.bulkOptIn();
        },

        async bulkOptIn() {
            const phoneNumbers = this.numbersToBeSingleOptedIn;
            const consentAcceptedBy = this.userId;
            const statusKind = SMS_OPT_STATUSES.SINGLE_OPT_IN;
            const consentConfirmationTime = `${moment().unix()}`;

            this.loading = true;
            const params = {
                phoneNumbers,
                consentAcceptedBy,
                statusKind,
                consentConfirmationTime,
                consentAcquisitionKind: CONSENT_ACQUISITION_KIND.USER_REPORTED_CONSENT,
            };

            try {
                await axios.put('/app/smsBroadcast/account/status/', params);

                this.$emit('continue');
            } catch (error) {
                this.$toast({ message: 'There was an error updating consent. Please try again.' });
            }
            this.loading = false;
        },
    },
};

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.compliance-header {
    font-weight: bold;
}

.compliance-actions {
    display: flex;
    align-self: self-end;
}

.compliance-list {
    margin: $spacing-300 0 $spacing-100;
    padding-left: 1.75rem;

    li {
        font-size: $font-size-md;
        list-style-type: disc;
        margin-bottom: $spacing-200;
        color: $color-text-subtle;
    }
}

.agreement-container {
    display: flex;
    margin-bottom: $spacing-100;
    margin-left: -0.2rem;

    .checkbox {
        padding-top: 0;
    }

    .checkbox-container {
        align-self: flex-start;
    }
}

.compliance-checkbox {
    --checkbox-align-items: flex-start;
}

.back-button {
    color: $color-text-subtle;
}
</style>
